import React from 'react';

import { assetsIcon } from '@atlaskit/logo/raw-icons';

/** Decorative product icon accompanying the localized Assets attribution name. */
export const AssetsAttributionIcon = (): React.JSX.Element => (
	<img src={assetsIcon} alt="" width={16} height={16} />
);
